import * as React from "react";
import { MoneyDisplayHelper } from "../../../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { StringHelper } from "../../../../../../../../../react-core/Helpers/StringHelper";
import { CurrencyCode } from "../../../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { WithdrawalsTransactionSummary } from "../../../../../../../../../Wrap/Models/Domains/Transactions/Summary/WithdrawalsTransactionSummary";
import { Table } from "../../../../../../../../Shared/Table/Table";

interface IWithdrawalsTableProps {
    data: Array<WithdrawalsTransactionSummary>;
}
export const WithdrawalsTable = (props: IWithdrawalsTableProps) => {
    const stringHelper = new StringHelper();
    return (
        <div>
            <Table
                data={props.data}
                rowCssWrapper={"product-heading"}
                col={[
                    {
                        title: "Product",
                        key: "ClAccountId",
                        render: (data, row, index) => {
                            return (
                                <>
                                    <span
                                        aria-hidden="true"
                                        className={"product-legend " + stringHelper.getDonutClass(row.ProductType, row.WrapperSubType)}
                                    ></span>
                                    <span className={stringHelper.getDonutClass(row.ProductType, row.WrapperSubType) + "-text"}>
                                        {row.ProductDisplayName}
                                    </span>
                                    <span className="account">{data}</span>
                                </>
                            );
                        },
                    },
                    {
                        title: "Tax free cash",
                        key: "TaxFreeCashAmount",
                        thCssWrapper: "cell-right",
                        tdCssWrapper: "cell-right",
                        render: (data, row, index) => {
                            return MoneyDisplayHelper.getMoneyFormatWithEmpty(
                                { Amount: data, Currency: CurrencyCode.GBP },
                                row.ProductDisplayName == "SIPP" ? "-" : "N/A",
                                true
                            );
                        },
                    },
                    {
                        title: "Drawdown income",
                        key: "DrawdownIncomeAmount",
                        thCssWrapper: "cell-right",
                        tdCssWrapper: "cell-right",
                        render: (data, row, index) => {
                            return MoneyDisplayHelper.getMoneyFormatWithEmpty(
                                { Amount: data, Currency: CurrencyCode.GBP },
                                row.ProductDisplayName == "SIPP" ? "-" : "N/A",
                                true
                            );
                        },
                    },
                    {
                        title: "Transfer",
                        key: "TransferAmount",
                        thCssWrapper: "cell-right",
                        tdCssWrapper: "cell-right",
                        render: (data, row, index) => {
                            return MoneyDisplayHelper.getMoneyFormatWithEmpty(
                                { Amount: data, Currency: CurrencyCode.GBP },
                                "-",
                                true
                            );
                        },
                    },
                    {
                        title: "Dividend",
                        key: "DividendAmount",
                        thCssWrapper: "cell-right",
                        tdCssWrapper: "cell-right",
                        render: (data, row, index) => {
                            return MoneyDisplayHelper.getMoneyFormatWithEmpty(
                                { Amount: data, Currency: CurrencyCode.GBP },
                                row.ProductDisplayName === "Aberdeen SIPP" || row.ProductDisplayName === "Aberdeen JSIPP" ? "N/A" : "-",
                                true
                            );
                        },
                    },
                    {
                        title: "Withdrawal",
                        key: "WithdrawalAmount",
                        thCssWrapper: "cell-right",
                        tdCssWrapper: "cell-right",
                        render: (data, row, index) => {
                            const shouldIncludePaye = !(row.ProductDisplayName === "Aberdeen SIPP" || row.ProductDisplayName === "Aberdeen JSIPP");
                            const calculatedAmount = row.WithdrawalAmount + (shouldIncludePaye ? row.PayeTaxAmount : 0);
                            return MoneyDisplayHelper.getMoneyFormatWithEmpty(
                                { Amount: calculatedAmount, Currency: CurrencyCode.GBP },
                                row.ProductDisplayName === "Aberdeen SIPP" || row.ProductDisplayName === "Aberdeen JSIPP" ? "N/A" : "-",
                                true
                            );
                        },
                    },
                    {
                        title: "Surrender",
                        key: "SurrenderAmount",
                        thCssWrapper: "cell-right",
                        tdCssWrapper: "cell-right",
                        render: (data, row, index) => {
                            return MoneyDisplayHelper.getMoneyFormatWithEmpty(
                                { Amount: data, Currency: CurrencyCode.GBP },
                                row.ProductDisplayName === "Aberdeen SIPP" || row.ProductDisplayName === "Aberdeen JSIPP" ? "N/A" : "-",
                                true
                            );
                        },
                    },
                    {
                        title: "Total",
                        key: "SurrenderAmount",
                        thCssWrapper: "cell-right",
                        tdCssWrapper: "cell-right",
                        render: (data, row, index) => {
                            const excludePaye = ["Aberdeen SIPP", "Aberdeen JSIPP"].includes(row.ProductDisplayName);
                            const payeAmount = excludePaye ? 0 : row.PayeTaxAmount;
                            return MoneyDisplayHelper.getMoneyFormatWithEmpty(
                                {
                                    Amount:
                                        row.TaxFreeCashAmount +
                                        row.TransferAmount +
                                        row.DividendAmount +
                                        row.WithdrawalAmount +
                                        row.SurrenderAmount +
                                        row.DrawdownIncomeAmount +
                                        payeAmount,
                                    Currency: CurrencyCode.GBP,
                                },
                                "-",
                                true
                            );
                        },
                    },
                ]}
                TotalBody={[
                    { data: "Portfolio total" },
                    {
                        data: MoneyDisplayHelper.getMoneyFormatWithEmpty(
                            {
                                Amount: (props.data || []).reduce((total, ele) => {
                                    return total + ele.TaxFreeCashAmount;
                                }, 0),
                                Currency: CurrencyCode.GBP,
                            },
                            "-",
                            true
                        ),
                        tfTdCssWrapper: "cell-right",
                    },
                    {
                        data: MoneyDisplayHelper.getMoneyFormatWithEmpty(
                            {
                                Amount: (props.data || []).reduce((total, ele) => {
                                    return total + ele.DrawdownIncomeAmount;
                                }, 0),
                                Currency: CurrencyCode.GBP,
                            },
                            "-",
                            true
                        ),
                        tfTdCssWrapper: "cell-right",
                    },
                    {
                        data: MoneyDisplayHelper.getMoneyFormatWithEmpty(
                            {
                                Amount: (props.data || []).reduce((total, ele) => {
                                    return total + ele.TransferAmount;
                                }, 0),
                                Currency: CurrencyCode.GBP,
                            },
                            "-",
                            true
                        ),
                        tfTdCssWrapper: "cell-right",
                    },
                    {
                        data: MoneyDisplayHelper.getMoneyFormatWithEmpty(
                            {
                                Amount: (props.data || []).reduce((total, ele) => {
                                    return total + ele.DividendAmount;
                                }, 0),
                                Currency: CurrencyCode.GBP,
                            },
                            "-",
                            true
                        ),
                        tfTdCssWrapper: "cell-right",
                    },
                    {
                        data: MoneyDisplayHelper.getMoneyFormatWithEmpty(
                            {
                                Amount: (props.data || []).reduce((total, ele) => {
                                    const excludePaye = ["Aberdeen SIPP", "Aberdeen JSIPP"].includes(ele.ProductDisplayName);
                                    const payeAmount = excludePaye ? 0 : ele.PayeTaxAmount;
                                    return total + ele.WithdrawalAmount + payeAmount;
                                }, 0),
                                Currency: CurrencyCode.GBP,
                            },
                            "-",
                            true
                        ),
                        tfTdCssWrapper: "cell-right",
                    },
                    {
                        data: MoneyDisplayHelper.getMoneyFormatWithEmpty(
                            {
                                Amount: (props.data || []).reduce((total, ele) => {
                                    return total + ele.SurrenderAmount;
                                }, 0),
                                Currency: CurrencyCode.GBP,
                            },
                            "-",
                            true
                        ),
                        tfTdCssWrapper: "cell-right",
                    },
                    {
                        data: MoneyDisplayHelper.getMoneyFormatWithEmpty(
                            {
                                Amount: (props.data || []).reduce((total, ele) => {
                                    const excludePaye = ["Aberdeen SIPP", "Aberdeen JSIPP"].includes(ele.ProductDisplayName);
                                    const payeAmount = excludePaye ? 0 : ele.PayeTaxAmount;
                                    return (
                                        total +
                                        ele.TaxFreeCashAmount +
                                        ele.DrawdownIncomeAmount +
                                        ele.TransferAmount +
                                        ele.DividendAmount +
                                        ele.SurrenderAmount +
                                        ele.WithdrawalAmount +
                                        payeAmount
                                    );
                                }, 0),
                                Currency: CurrencyCode.GBP,
                            },
                            "-",
                            true
                        ),
                        tfTdCssWrapper: "cell-right",
                    },
                ]}
            ></Table>
        </div>
    );
};
